
const API_URL = 'https://api-5dvhxg2zwq-uc.a.run.app';
// const API_URL = 'http://127.0.0.1:5001/chatupweb/us-central1/api';
// const API_URL = 'https://4a99-88-20-236-86.ngrok-free.app/chatupweb/us-central1/api';
const SEND_MESSAGE = `${API_URL}/chat/sendMessage`;
const GET_USER_CHAT_LIST = `${API_URL}/chat/getUserChatList`;
const DELETE_CHAT = `${API_URL}/chat/deleteChat`;
const UPDATE_CHAT_NAME = `${API_URL}/chat/updateChatName`;
const DELETE_CHAT_MESSAGE = `${API_URL}/chat/deleteChatMessage`;
const RESEND_CHAT_MESSAGE = `${API_URL}/chat/resendMessage`;
const MJ_OPERATIONS = `${API_URL}/chat/mjOperation`;
const CANCEL_REQUEST = `${API_URL}/chat/cancelMessageRequest`;
const IMPROVE_PROMPT = `${API_URL}/chat/improvePrompt`;
const SPEECH_TO_TEXT = `${API_URL}/chat/speechToText`;
const GET_DEFAULT_PROMPTS = `${API_URL}/chat/defaultPrompts`;
const SET_SYSTEM_PROMPT = `${API_URL}/chat/setSystemPrompt`;
const SET_MESSAGE_MEMORY_LIMIT = `${API_URL}/chat/setMessageMemoryLimit`;
const GET_FILE_TEXT_LENGTH = `${API_URL}/chat/getFileTextLength`;

const CREATE_CHAT_FOLDER = `${API_URL}/folder/create`;
const EDIT_CHAT_FOLDER = `${API_URL}/folder/edit`;
const EDIT_PARENT_FOLDER = `${API_URL}/folder/editParent`;
const EDIT_FOLDER_CHAT_LIST = `${API_URL}/folder/editFolderChatList`;
const DELETE_CHAT_FOLDER = `${API_URL}/folder/delete`;

const STRIPE_GET_PAYMENT_LINK = `${API_URL}/stripe/getPaymentLink`;
const STRIPE_GET_BILLING_PORTAL_LINK = `${API_URL}/stripe/getBillingPortalLink`;
const STRIPE_GET_TRIAL_PAYMENT_LINK = `${API_URL}/stripe/getTrialPaymentLink`;
const STRIPE_CREATE_PAYMENT_LINK_FOR_RESET_COUNTER = `${API_URL}/stripe/createPaymentLinkForResetCounter`;

const CANVA_SUGGEST_EDIT = `${API_URL}/canva/suggestEdit`;
const CANVA_ADD_FINISHING_TOUCHES = `${API_URL}/canva/addFinishingTouches`;
const CANVA_MODIFY_LENGTH = `${API_URL}/canva/modifyLength`;
const CANVA_MODIFY_READING_LEVEL = `${API_URL}/canva/modifyReadingLevel`;
const CANVA_TRANSLATE = `${API_URL}/canva/translate`;
const CANVA_GET_INTERESTING_FACT = `${API_URL}/canva/interestingFact`;
const CANVA_EDIT_TITLE = `${API_URL}/canva/editTitle`;

// Deep Research endpoints
const DEEP_RESEARCH_ASK_DETAILS = `${API_URL}/deepresearch/askDetails`;
const DEEP_RESEARCH_START = `${API_URL}/deepresearch/start`;
const DEEP_RESEARCH_CHECK_LIMITS = `${API_URL}/deepresearch/checkLimits`;
const DEEP_RESEARCH_EXPORT_PDF = `${API_URL}/deepresearch/exportPDF`;

const VERIFY_EMAIL = `${API_URL}/verify/email`;

const CONTACT_FORM = `${API_URL}/contact/form`;

const USER_SET_CID = `${API_URL}/user/setCID`;
const USER_SET_REF = `${API_URL}/user/setRef`;
const USER_SET_EID = `${API_URL}/user/setEID`;
const USER_SET_TTCLID = `${API_URL}/user/setTTCLID`;
const USER_HIDE_OFFER_POPUP = `${API_URL}/user/setHideOfferPopup`;
const USER_SET_HAS_SEEN_MODEL_WARNING = `${API_URL}/user/setHideModelWarning`;
const USER_HIDE_THUNDER_ATTACHMENT_WARNING = `${API_URL}/user/setHideThunderAttachmentWarning`;

const DOCUMENT_GET_CONTENT = `${API_URL}/document/getContent`;
const DOCUMENT_UPDATE_CONTENT = `${API_URL}/document/updateContent`;

module.exports = {SEND_MESSAGE, GET_USER_CHAT_LIST, DELETE_CHAT, UPDATE_CHAT_NAME, MJ_OPERATIONS, CANCEL_REQUEST, 
    DELETE_CHAT_MESSAGE, RESEND_CHAT_MESSAGE, STRIPE_GET_PAYMENT_LINK, STRIPE_GET_BILLING_PORTAL_LINK, STRIPE_GET_TRIAL_PAYMENT_LINK, 
    VERIFY_EMAIL, 
    CONTACT_FORM, USER_SET_CID, CREATE_CHAT_FOLDER, EDIT_CHAT_FOLDER, EDIT_PARENT_FOLDER, EDIT_FOLDER_CHAT_LIST, SET_SYSTEM_PROMPT,
    DELETE_CHAT_FOLDER, USER_SET_EID, IMPROVE_PROMPT, SPEECH_TO_TEXT, 
    GET_DEFAULT_PROMPTS, 
    USER_SET_REF, SET_MESSAGE_MEMORY_LIMIT, CANVA_ADD_FINISHING_TOUCHES, CANVA_MODIFY_LENGTH, CANVA_MODIFY_READING_LEVEL,
    CANVA_TRANSLATE, CANVA_SUGGEST_EDIT, CANVA_EDIT_TITLE, USER_SET_TTCLID, CANVA_GET_INTERESTING_FACT, DOCUMENT_GET_CONTENT, 
    DOCUMENT_UPDATE_CONTENT, GET_FILE_TEXT_LENGTH, USER_HIDE_OFFER_POPUP, USER_SET_HAS_SEEN_MODEL_WARNING, USER_HIDE_THUNDER_ATTACHMENT_WARNING,
    STRIPE_CREATE_PAYMENT_LINK_FOR_RESET_COUNTER, DEEP_RESEARCH_ASK_DETAILS, DEEP_RESEARCH_START, DEEP_RESEARCH_CHECK_LIMITS, DEEP_RESEARCH_EXPORT_PDF};
